import React, { useEffect } from 'react';
import { Cross, SearchBackContainer } from './MainHeader/styled';
import { images } from '../../../Constants/ImageUrls';
import { useRouter } from 'next/router';
import Image from 'next/image';

function MobileSearch(props) {
  const {
    handleInputChange,
    showSearchResultHandler,
    searchString,
    setShowCross,
    showCross,
    setSearchString,
    changeToSearchRoute,
    showInput,
  } = props;

  const router = useRouter();
  const crossHandler = () => {
    setSearchString('');
  };

  useEffect(() => {
    if (searchString === '') {
      setShowCross(false);
    } else {
      setShowCross(true);
    }
  }, [searchString]);

  return (
    <>
      {showInput ? (
        <form onSubmit={(e) => changeToSearchRoute(e, searchString)}>
          <input
            type="text"
            placeholder="Search for weightloss tea.."
            onChange={handleInputChange}
            onClick={showSearchResultHandler}
            id="searchInput"
            autoComplete="off"
            value={searchString}
          />

          <SearchBackContainer>
            <Image
              className="search_back"
              src={images.backArrowCart}
              alt="back search"
              onClick={() => {
                router.back();
              }}
              height={19}
              width={19}
              mobile
            />
          </SearchBackContainer>
          {showCross ? (
            <Cross onClick={crossHandler}>
              <span>&times;</span>
            </Cross>
          ) : null}
        </form>
      ) : null}
    </>
  );
}

export default MobileSearch;
